import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Стили Mantine грузятся первыми: собственные правила `index.css` должны их перекрывать,
// а не наоборот. Без этого импорта сборка проходит и тесты в jsdom зелены — стили там
// никто не считает, — но панель в браузере открывается без оформления (AD-A13).
import '@mantine/core/styles.css';

import { App } from './app/App';
import './index.css';

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
